import { render, staticRenderFns } from "./miniProgram.vue?vue&type=template&id=6897e0d4&scoped=true"
import script from "./miniProgram.vue?vue&type=script&lang=js"
export * from "./miniProgram.vue?vue&type=script&lang=js"
import style0 from "./miniProgram.vue?vue&type=style&index=0&id=6897e0d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897e0d4",
  null
  
)

export default component.exports